import { gql } from "@apollo/client";

export default gql`
  query getChangelogDeliveries($input: ListDeliveriesInput){
    getChangelogDeliveries(input: $input){
        success
        data{
            docs{
                _id
                announcement
                cPerson
                customer
                channels
                readAt
                reaction
                comment
                createdAt
            }
            totalDocs
            page
            totalPages
            hasNextPage
        }
        error
        message
    }
}
`
